import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Card, Col, ListGroup, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { LinkButton } from '../../styles/components/common/Button';
import ItemShow from '../../components/Form/ItemShow';
import { toast } from 'react-hot-toast';
import 'react-progress-2/main.css';
import { Loading } from '../../components/Loading';
import { Label } from 'reactstrap';

const CustomerShow = () => {
      const { customerId } = useParams();
      const [user, setUser] = useState([]);
      const [loadingData, setLoadingData] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      const loadData = async () => {
            setLoadingData(true);

            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/customers/${customerId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setUser(response.data.user);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader>
                                          <CardTitle>
                                                Customer Details
                                          </CardTitle>
                                          <CardLinks>
                                                <LinkButton to="/dashboard/customers">
                                                      Back
                                                </LinkButton>
                                          </CardLinks>
                                    </CardHeader>
                                    <Card.Body>
                                          {!loadingData ? (
                                                <Row>
                                                      <Col lg={6}>
                                                            <ListGroup>
                                                                  <ItemShow
                                                                        title="Full Name"
                                                                        value={
                                                                              user.name
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Email"
                                                                        value={
                                                                              user.email
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Phone"
                                                                        value={
                                                                              user.phone_number
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Verified"
                                                                        value={
                                                                              user.verified ===
                                                                              1 ? (
                                                                                    <Label className="bg-success px-2 rounded text-white">
                                                                                          Verified
                                                                                    </Label>
                                                                              ) : (
                                                                                    <Label className="bg-danger px-2 rounded text-white">
                                                                                          Not
                                                                                          Verified
                                                                                    </Label>
                                                                              )
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Created By"
                                                                        value={
                                                                              user.user_name
                                                                        }
                                                                  />
                                                                  <ItemShow
                                                                        title="Created Date"
                                                                        value={
                                                                              user.date
                                                                        }
                                                                  />
                                                            </ListGroup>
                                                      </Col>
                                                      <Col lg={6}>
                                                            {user.photo && (
                                                                  <ListGroup>
                                                                        <img
                                                                              src={
                                                                                    user.photo
                                                                              }
                                                                              alt={
                                                                                    user.name
                                                                              }
                                                                              className="w-100"
                                                                        />
                                                                  </ListGroup>
                                                            )}
                                                      </Col>
                                                </Row>
                                          ) : (
                                                <>
                                                      <div
                                                            className="text-center d-flex align-items-center justify-content-center w-100"
                                                            style={{
                                                                  height: '30vh'
                                                            }}
                                                      >
                                                            <Loading />
                                                      </div>
                                                </>
                                          )}
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default CustomerShow;
